<script setup lang="ts">
withDefaults(
  defineProps<{
    src?: string;
  }>(),
  {
    src: '/assets/billing/payment-method-illustration.png',
  },
);
</script>

<template>
  <div class="hidden h-full w-[420px] shrink-0 overflow-hidden bg-surface-secondary md:flex">
    <img :src="src" class="h-full w-full object-cover" aria-hidden="true" />
  </div>
</template>
